import styled from 'styled-components';
import { tokens } from '../../public/tokens';
import { MOBILE_MEDIA_QUERY } from './breakpoints';

/**
 * Wrappers.js and Container can be merged at some point.
 * components/common/GlobalElements/Wrappers.js
 */

const { globals } = tokens;

/**
 * Height of the app header, which the mobile full-screen container sits below.
 * Kept in step with HEADER_HEIGHT in utils/showUploadPhotoModal.js.
 */
const MOBILE_HEADER_HEIGHT = '48px';

/**
 * Padded vertical shell for a dialog body or a standalone page. Fills the
 * viewport below the header on mobile so its content can anchor to the bottom.
 */
export const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    padding: globals['spacing-xl'],
    textAlign: 'left',

    [MOBILE_MEDIA_QUERY]: {
        minHeight: `calc(100vh - ${MOBILE_HEADER_HEIGHT})`,
        padding: globals['spacing-md'],
    },
});
